module.exports = __webpack_public_path__ + "static/media/login.66e6bd91.jpg";